import { render, staticRenderFns } from "./menuNavBar.vue?vue&type=template&id=61b33677"
import script from "./menuNavBar.vue?vue&type=script&lang=js"
export * from "./menuNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports